import { Button, Modal, Select, TextInput, Textarea } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../Reducers/store';
import { Manufacturer } from '../../Models/Manufacturer';
import ManufacturerApi from '../../Api/ManufacturerApi';

export default function AddManufacturerModal({
  show,
  setShow,
  getManufacturers,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  getManufacturers: () => Promise<void> | undefined;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { states } = useAppSelector((state) => state.commonFields);
  const { userModel } = useAppSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [formData, setFormData] = useState<Manufacturer>({
    id: 0,
    name: '',
    address: '',
    city: '',
    stateId: null,
    zip: null,
    phone: '',
    email: '',
    description: '',
    website: '',
    rimssId: null,
    rimssOemvendorNumber: null,
    rimssPricebookId: null,
    active: null,
    parentManufacturerId: null,
    primaryImageURL: '',
    files: [],
    state: null,
  });

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    setButtonDisabled(true);
    e.preventDefault();
    try {
      setIsLoading(true);
      return ManufacturerApi.addUpdateManufacturer(formData)
        .then((res) => {
          if (res.data.success) {
            toast.success('Success');
            setIsLoading(false);
            setButtonDisabled(false);
            getManufacturers();
            setShow(false);
            // navigate(`/manufacturer/${res.data.affectedEntityIdentifier}`);
          } else {
            toast.error(res.data.message);
            setIsLoading(false);
            setButtonDisabled(false);
          }
        })
        .catch((err) => {
          toast.error('Error: ' + err);
          setIsLoading(false);
          setButtonDisabled(false);
        });
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      setButtonDisabled(false);
    }
  };
  function onCloseModal() {
    setShow(false);
  }
  return (
    <Modal show={show} size='4xl' onClose={onCloseModal} popup>
      <Modal.Header></Modal.Header>
      <Modal.Body>
        <div className='w-full'>
          <div className='w-full'>
            <div className='mx-1 flex items-end justify-center'>
              <div className='flex flex-1 justify-center'>
                <h1 className='text-gray-900 font-bold text-4xl'>
                  Add Manufacturer
                </h1>
              </div>
            </div>
          </div>

          <div>
            <div className='container mx-auto p-2'>
              <div className='md:flex no-wrap md:-mx-2 '>
                <div className='w-full'>
                  <div className='bg-white'>
                    <div className='flex items-center space-x-2 font-bold text-gray-500 leading-8'>
                      <span className='tracking-wide uppercase text-3xl'>
                        Information
                      </span>
                    </div>
                    <hr className='bg-gray-300 h-[5px]'></hr>
                    <form onSubmit={onSubmit}>
                      <div className='text-gray-500'>
                        <div className='grid grid-cols-[20%_80%] text-xl'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Name:
                            </div>
                          </div>
                          <div className='w-full lg:w-1/2'>
                            <TextInput
                              id='name'
                              name='name'
                              type='text'
                              placeholder='Name...'
                              onChange={handleChangeInput}
                              value={formData.name ?? ''}
                              sizing='md'
                              required
                            />
                          </div>
                        </div>
                        <hr className='bg-gray-300 h-[2px]'></hr>
                        <div className='grid grid-cols-[20%_80%] text-xl'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Email:
                            </div>
                          </div>
                          <div className='w-full lg:w-1/2'>
                            <TextInput
                              id='email'
                              name='email'
                              type='text'
                              placeholder='Email...'
                              onChange={handleChangeInput}
                              value={formData.email ?? ''}
                              sizing='md'
                            />
                          </div>
                        </div>
                        <hr className='bg-gray-300 h-[2px]'></hr>
                        <div className='grid grid-cols-[20%_80%] text-xl'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Phone:
                            </div>
                          </div>
                          <div className='w-full lg:w-1/2'>
                            <TextInput
                              id='phone'
                              name='phone'
                              type='text'
                              placeholder='Phone...'
                              onChange={handleChangeInput}
                              value={formData.phone ?? ''}
                              sizing='md'
                            />
                          </div>
                        </div>
                        <hr className='bg-gray-300 h-[2px]'></hr>
                        <div className='grid grid-cols-[20%_80%] text-xl'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Address:
                            </div>
                          </div>
                          <div className='flex flex-col lg:flex-row'>
                            <div className='w-full lg:w-1/3'>
                              <TextInput
                                id='address'
                                name='address'
                                type='text'
                                placeholder='Street...'
                                onChange={handleChangeInput}
                                value={formData.address ?? ''}
                                sizing='md'
                              />
                            </div>
                            <div className='w-full lg:w-2/3 flex'>
                              <div className='w-1/3'>
                                <TextInput
                                  id='city'
                                  name='city'
                                  type='text'
                                  placeholder='City...'
                                  onChange={handleChangeInput}
                                  value={formData.city ?? ''}
                                  sizing='md'
                                />
                              </div>
                              <div className='w-1/3'>
                                <Select
                                  id='stateId'
                                  name='stateId'
                                  onChange={handleChangeSelect}
                                  value={formData.stateId ?? ''}
                                  sizing='md'
                                >
                                  <option>(State)</option>
                                  {states.map((state) => (
                                    <option key={state.id} value={state.id}>
                                      {state.name}
                                    </option>
                                  ))}
                                </Select>
                              </div>
                              <div className='w-1/3'>
                                <TextInput
                                  id='zip'
                                  name='zip'
                                  type='text'
                                  placeholder='Zip...'
                                  onChange={handleChangeInput}
                                  value={formData.zip ?? ''}
                                  sizing='md'
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr className='bg-gray-300 h-[2px]'></hr>
                        <div className='grid grid-cols-[20%_80%] text-xl'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Rimss Id:
                            </div>
                          </div>
                          <div className='w-full lg:w-1/2'>
                            <TextInput
                              id='rimssId'
                              name='rimssId'
                              type='text'
                              placeholder='Rimss Id...'
                              onChange={handleChangeInput}
                              value={formData.rimssId ?? ''}
                              sizing='md'
                            />
                          </div>
                        </div>
                        <hr className='bg-gray-300 h-[2px]'></hr>
                        <div className='grid grid-cols-[20%_80%] text-xl'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Website:
                            </div>
                          </div>
                          <div className='w-full lg:w-1/2'>
                            <TextInput
                              id='website'
                              name='website'
                              type='text'
                              placeholder='Website...'
                              onChange={handleChangeInput}
                              value={formData.website ?? ''}
                              sizing='md'
                            />
                          </div>
                        </div>
                        <hr className='bg-gray-300 h-[2px]'></hr>
                        <div className='grid grid-cols-[20%_80%] text-xl'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Description:
                            </div>
                          </div>
                          <div>
                            <Textarea
                              id='description'
                              name='description'
                              placeholder='Description...'
                              onChange={handleChangeTextArea}
                              value={formData.description ?? ''}
                              //   sizing='md'
                              rows={4}
                            />
                          </div>
                        </div>
                      </div>
                      <div className='flex justify-end pt-2'>
                        <Button
                          disabled={buttonDisabled}
                          type='submit'
                          className='buttonMain'
                        >
                          Save
                        </Button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
